import React from 'react';
type Badge = {
  label: string;
  content: React.ReactNode;
};
const badgeBase = 'flex h-8 w-[52px] flex-none items-center justify-center rounded-[6px] border border-hairline bg-white';
const badges: Badge[] = [{
  label: 'Visa',
  content: <span className="font-display text-[11px] font-bold italic tracking-tight text-[#1A1F71]" data-id="element-143" data-mp="29ruipq5oe6i2">
        VISA
      </span>
}, {
  label: 'Mastercard',
  content: <span className="flex items-center" data-id="element-144" data-mp="1zt4yvru7ybz6">
        <span className="h-4 w-4 rounded-full bg-[#EB001B]" data-id="element-145" data-mp="1v0v9qe0xhfxy" />
        <span className="-ml-1.5 h-4 w-4 rounded-full bg-[#F79E1B] opacity-90" data-id="element-146" data-mp="1uzk92n2s4ob2" />
      </span>
}, {
  label: 'American Express',
  content: <span className="rounded-[3px] bg-[#2E77BC] px-1 py-0.5 text-[8px] font-bold tracking-tight text-white" data-id="element-147" data-mp="1m0p1b6k3765n">
        AMEX
      </span>
}, {
  label: 'Apple Pay',
  content: <span className="text-[11px] font-semibold text-ink" data-id="element-148" data-mp="1c29br80pk4y9"> Pay</span>
}, {
  label: 'Google Pay',
  content: <span className="text-[11px] font-semibold text-ink" data-id="element-149" data-mp="24oinv2ol5h6k">
        <span className="text-[#4285F4]" data-id="element-150" data-mp="24mxs59qjbs74">G</span>
        <span className="text-[#EA4335]" data-id="element-151" data-mp="29gk7j9o32a6m">o</span>
        <span className="text-[#FBBC05]" data-id="element-152" data-mp="29hbvpzfcp5mv">o</span>
        <span className="text-[#34A853]" data-id="element-153" data-mp="1urnqin41tmtv">g</span>
        <span className="text-[#4285F4]" data-id="element-154" data-mp="1uoruj4brh882">l</span>
        <span className="text-[#EA4335]" data-id="element-155" data-mp="1zqqwc9rurx2w">e</span> Pay
      </span>
}, {
  label: 'Shop Pay',
  content: <span className="rounded-[3px] bg-[#5A31F4] px-1.5 py-0.5 text-[8px] font-bold tracking-tight text-white" data-id="element-156" data-mp="2nftc1c2xffur">
        shop Pay
      </span>
}];
export function PaymentIcons() {
  return <ul className="flex flex-wrap items-center justify-center gap-1.5" aria-label="Accepted payment methods" data-id="element-157" data-mp="2dgkkepvjadbk">
      {badges.map(badge => <li key={badge.label} className={badgeBase} title={badge.label} data-id="element-158" data-mp="12272e1ngos3g">
          <span className="sr-only" data-id="element-159" data-mp="1241q1nq4ayb8">{badge.label}</span>
          <span aria-hidden="true" className="flex items-center justify-center" data-id="element-160" data-mp="17236e0w5sjj0">
            {badge.content}
          </span>
        </li>)}
    </ul>;
}